<template>
  <section class="wishlists-add">
    <h2 id="userModalLabel">Føj til ønskeliste</h2>
    <div
      v-dragscroll.x
      v-on:dragscrollstart="setScrollTrue"
      v-on:dragscrollend="setScrollFalse"
    >
    <div>
      <button class="btn wishlist add" @click="openAddWishlistModal">
        <span class="fs-1">+</span><span>Opret ny ønskeliste</span>
      </button>
    </div>
      <div v-for="(wishlist, index) in wishlists" :key="index">
        <button
          :class="[
            'btn wishlist',
            { 'in-list': wishlist.documents.includes(favoriteId) },
          ]"
          @click="
            toggleWishlist(wishlist, wishlist.documents.includes(favoriteId))
          "
        >
          <span
            :style="[
              wishlist.image
                ? {
                    backgroundImage: 'url(' + wishlist.image + ')',
                  }
                : {
                    backgroundColor: '#e8edef',
                  },
            ]"
          >
          </span>
        </button>
        <a :href="pageUrls.pageProfileFavoriteList + '#?listid=' + wishlist.id">{{ wishlist.name }} ({{ wishlist.documents.length }})</a>
      </div>
    </div>
  </section>
  <div role="alert" :class="[{ show: documentToggled }, 'favorite-info-box']">
    {{ wishlistInfo }}
  </div>
  <add-wishlist-modal v-if="showAddWishlistModal" />
</template>
<script>
import AddWishlistModal from "./Modals/AddWishlistModal.vue";
export default {
  name: "Wishlists",
  components: {
    AddWishlistModal,
  },
  props: ["favoriteId"],
   mounted() {
     this.$store.dispatch("getPageUrls");
  },
  data() {
    return {
      // wishlists: this.$store.state.wishlists,
      showAddWishlistModal: false,
      isScrolling: false,
      documentToggled: false,
      wishlistInfo: "",
    };
  },
  computed: {
    wishlists() {
      return this.$store.state.wishlists;
    },
    addedDocuments() {
      return this.$store.state.addedDocuments;
    },
    pageUrls() {
      return this.$store.state.pageUrls;
    },
  },
  methods: {
    toggleWishlist: function (wishlist, inList) {
      if (this.isScrolling) return; // If drag is going on, don't trigger event
      let params = { listId: wishlist.id, documentId: this.favoriteId };
      // TODO: Manage clear timeout
      if (inList) {
        this.$store.dispatch("deleteDocumentFromWishlist", params).then(() => {
          this.wishlistInfo = "Fjernet fra ønskeliste " + wishlist.name;
          this.documentToggled = true;
          setTimeout(() => {
            this.documentToggled = false;
          }, 2000);
        });
      } else {
        this.$store.dispatch("addDocumentToWishlist", params).then(() => {
          this.wishlistInfo = "Tilføjet til ønskeliste " + wishlist.name;
          this.documentToggled = true;
          setTimeout(() => {
            this.documentToggled = false;
          }, 2000);
        });
      }
      this.updateFavoriteButtons(inList);
    },
    updateFavoriteButtons: function (inList) {
      const favId = this.favoriteId;
      if (inList) {
        const addedDocumentsIndexes = this.addedDocuments.reduce(function (
          newArray,
          el,
          i
        ) {
          if (el === favId) newArray.push(i);
          return newArray;
        },
        []);
        if (addedDocumentsIndexes.length - 1 < 1) {
          const favoriteBtns = document.querySelectorAll(
            '[data-favoriteid="' + favId + '"]'
          );
          favoriteBtns.forEach((el) => el.classList.remove("in-list"));
        }
      } else {
        const favoriteButtons = document.querySelectorAll(
          '[data-favoriteid="' + favId + '"]'
        );
        favoriteButtons.forEach((el) => el.classList.add("in-list"));
      }
    },
    setScrollTrue: function () {
      this.isScrolling = true;
    },
    setScrollFalse: function () {
      // We need the timeout to not trigger button click on mouse up at scroll end
      setTimeout(() => {
        this.isScrolling = false;
      }, 0);
    },
    openAddWishlistModal: function () {
      this.showAddWishlistModal = true;
    },
    closeAddWishlistModal: function () {
      this.showAddWishlistModal = false;
    },
  },
};
</script>